module.exports = __webpack_public_path__ + "img/insurance-card-pdp.8357957.png";